export default "__VITE_ASSET__7088981a__"